import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { GoalDrawerContent } from '../models/goal-drawer-content.model';

@Injectable({
  providedIn: 'root',
})
export class GoalDrawerContentService<T> {
  private _openDrawer = new ReplaySubject<boolean>(1);
  public readonly openDrawer$ = this._openDrawer.asObservable();

  private _drawerContent = new ReplaySubject<GoalDrawerContent<T>>(1);
  public readonly drawerContent$ = this._drawerContent.asObservable();

  constructor() {
    console.log('GoalDrawerContentService');
  }

  openDrawer(content?: GoalDrawerContent<T>) {
    if (content) {
      this._drawerContent.next(content);
    }

    this._openDrawer.next(true);
  }

  closeDrawer() {
    this._openDrawer.next(false);
  }

  setDrawerContent(content: GoalDrawerContent<T>) {
    this._drawerContent.next(content);
  }
}
